// This var is defined as a global using the webpack DefinePlugin in webpack.common.js
// It resolves to the git hash of the currently deployed code.
export default process.env.WEB_VERSION;
